/* unsafe-eval */

/**
 * Globals
 */
import globals from "imports/globals";

/**
 * jQuery
 */
import $ from "cash-dom";

$(document).ready(function () {
    if (globals.debug) console.log("document ready");
    $("html").addClass("document-ready");
});

$(window).on("load", function () {
    if (globals.debug) console.log("window loaded");
    $("html").addClass("window-loaded");
    // window.dispatchEvent(new Event("resize"));
});

$(window).on("resizeEnd", function () {
    if (globals.debug) console.log(`window resized to ${window.innerWidth} x ${window.innerHeight}px`);
});

/**
 * Events
 */
import escKey from "imports/event-esc-key";
import menuToggle from "imports/event-menu-toggle";
import resize from "imports/event-resize";
import scrollDirectionChange from "imports/event-scroll-direction-change";
import viewportOrientationChange from "imports/event-viewport-orientation-change";

/**
 * Components
 */
// import l10n from "imports/component-l10n";
import batchLoad from "imports/component-batch-load";
import customAnimations from "imports/component-custom-animations";
import dynamicVariables from "imports/component-dynamic-variables";
// import enter from "imports/component-enter";
import fillProportionally from "imports/component-fill-proportionally";
import fitProportionally from "imports/component-fit-proportionally";
import footerPages from "imports/component-footer-pages";
// import hero from "imports/component-hero";
import credit from "imports/component-credit";
// import lazyLoad from "imports/component-lazy-load";
// import lightbox from "imports/component-lightbox";
import masonry from "imports/component-masonry";
// import navigation from "imports/component-navigation";
// import outro from "imports/component-outro";
// import parallax from "imports/component-parallax";
// import preloader from "imports/component-preloader";
import readMore from "imports/component-read-more";
// import scrollIndicator from "imports/component-scroll-indicator";
import scrollTrigger from "imports/component-scroll-trigger";
import splitText from "imports/component-split-text";
import tabFocus from "imports/component-tab-focus";
import ui from "imports/component-ui";

/**
 * Layouts
 */
// import accordion from "imports/layout-accordion";
// import audio from "imports/layout-audio";
// import contactSheet from "imports/layout-image-gallery";
// import draggable from "imports/layout-draggable-slider";
// import horizontalScroll from "imports/layout-horizontal-scroll";
// import hotspot from "imports/layout-hotspot";
// import panningImage from "imports/layout-panning-image";
// import scrollableVideo from "imports/layout-scrollable-video";
// import slider from "imports/layout-slider";
// import stickyImage from "imports/layout-sticky-image";
// import stickyLottie from "imports/layout-sticky-lottie";
// import video from "imports/layout-video";
